/* 全局有三个参数 
 * # ___PROJECT 项目名称
 * # ___ENV 环境模式 development || production
 * # ___VERSION 版本号（不带v）
 * 建议项目内只在本文件([project]/config.js)上直接使用，其他的项目模块与组件等用到则使用 set 的方法传入配置
*/
// import "babel-polyfill";

//通用函数库
import * as Com from './../common'
window.Com = Com;

// 加载通用样式
import 'static/css/reset.css'

//获取数据插件 like ajax
import * as ServiceConfig from './serviceConfig'
import * as Service from 'build/plugs/service'
//ServiceConfig => {devUrl,resources,caches}
Vue.use(Service,{
  ...ServiceConfig //展开基础数据

  //如果定义了该方法,当 接口返回数据 status !== 1 时将调用该方法
  //用于统一处理接口 报错信息
  , alertFn: (msg = '未知信息', status) => {
    alert("服务端返回信息：" + msg);
  }

  //申请接口前调用
  //一般用于显示 loading
	/* ,loadingFn:()=>{
	    Com.show();
	} */

  //申请接口完成后调用
  //一般用于关闭 loading
	/* ,loadedFn:()=>{
	    Com.hide(0,true);
	} */

  , baseData: {
    //	    key:'b15ae13796ea20b4'
    //	    ,langType:0
  }

  //,jsonp:true

});

//主页面组件
import orderLocation from './index.vue'

//去掉提示 可取消
Vue.config.productionTip = false;

//开始
const vm = new Vue({
  template: "<App/>"
  , components: {

  }
  , render: h => h(orderLocation)
}).$mount('#app');

Com.set({vm})




// WEBPACK FOOTER //
// core-dms/projects/candao-dms-std/orderLocation/config.js